<template>
  <v-card>
    <v-alert
      class="mt-3"
      color="green lighten-4"
      colored-border
      border="left"
    >
      <v-card-text class="py-0">
        <v-row
          dense
          align="center"
          justify="space-between"
        >
          <v-col>
            <h3 class="title">
              {{ item.product.title }}
            </h3>
          </v-col>
          <v-col
            v-show="item.invoice"
            cols="2"
            class="d-flex justify-left"
          >
            <InvoicePaymentsLabel
              v-show="item.invoice"
              :invoice-amount="invoiceAmount"
              :payments-amount="paymentAmount"
            />
          </v-col>

          <v-col
            v-show="item.invoice"
            cols="3"
          >
            <InvoiceSelect
              v-model="item.invoice"
              :client-id="clientId"
              :product-id="item.product.id"
              label="Рахунок"
              @change="change"
            />
          </v-col>

          <v-col
            class="text-sm-center"
            cols="1"
          >
            <v-btn
              large
              icon
              @click="remove"
            >
              <v-icon>delete_outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <div v-if="item.trackVersions">
          <v-row>
            <v-col
              cols="4"
            >
              <v-select
                v-model="item.version"
                :items="item.versions"
                label="Версія у клієнта"
                hide-details
                dense
                outlined
                clearable
                attach
                :error="item.isOverdue"
                @input="change"
              >
                <template
                  v-if="item.version && item.isOverdue"
                  slot="append-outer"
                >
                  <v-tooltip
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        color="red"
                        v-on="on"
                      >
                        mdi-alert-circle-outline
                      </v-icon>
                    </template>
                    <span>Версія прострочена</span>
                  </v-tooltip>
                </template>
              </v-select>
            </v-col>
            <v-col
              cols="4"
            >
              <CustomTextField
                readonly
                label="Актуальна версія"
                :value="item.actualVersion"
              />
            </v-col>
            <v-col cols="3">
              <CustomTextField
                v-model="item.regNumber"
                label="Регістраційний номер"
                @input="change"
              />
            </v-col>
          </v-row>
          <v-row class="align-center">
            <v-col cols="4">
              <CustomTextField
                v-model="item.notes"
                label="Примітки"
                @input="change"
              />
            </v-col>
            <v-col cols="4">
              <CustomTextField
                v-model="item.jiraIssueKey"
                label="Jira"
                append-icon="search"
                :loading="loading"
                @click:append="openIssue(item.jiraIssueKey)"
                @change="assignJiraIssue(item)"
              />
            </v-col>
            <v-col
              cols="3"
            >
              <v-switch
                v-model="item.updateByClient"
                :label="item.updateByClient ? 'Оновлюється самостійно' : 'Оновлюється TQM systems'"
                color="green"
                hide-details
                @change="change"
              />
            </v-col>
          </v-row>
        </div>

        <v-row v-else>
          <v-col cols="4">
            <CustomTextField
              v-model="item.regNumber"
              label="Регістраційний номер"
              @input="change"
            />
          </v-col>
          <v-col cols="4">
            <CustomTextField
              v-model="item.notes"
              label="Примітки"
              @input="change"
            />
          </v-col>
          <v-col cols="3">
            <CustomTextField
              v-model="item.jiraIssueKey"
              label="Jira"
              append-icon="search"
              :loading="loading"
              @click:append="openIssue(item.jiraIssueKey)"
              @change="assignJiraIssue(item)"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-alert>
  </v-card>
</template>

<script>
import InvoicePaymentsLabel from "@/views/operations/invoices/InvoicePaymentsLabel.vue";
import InvoiceSelect from "@/views/operations/invoices/InvoiceSelect.vue";

import { getInvoice } from "@/backend/invoicesApi.js";
import { getPaymentInvoices } from "@/backend/paymentsApi.js";
import { assignJiraIssue } from "@/backend/productsApi.js";

export default {
  components: {
    InvoicePaymentsLabel,
    InvoiceSelect,
  },
  props: ["item", "id"],
  data: () => ({
    invoiceAmount: null,
    paymentAmount: null,
    clientId: null,
    loading: false,
  }),
  watch: {
    item: {
      handler(val) {
        if (val.invoice){
          this.getInvoice();
          this.getPayment();
        }
      },
      immediate: true,
    },
    id: {
      handler(val) {
        if (val){
          this.clientId = +val;
        }
      },
      immediate: true,
    },
  },
  methods: {
    remove() {
      this.$emit("remove");
    },
    change() {
      this.$emit("change");
    },
    openIssue(jiraIssueKey) {
      window.open(
        `https://atominc.atlassian.net/browse/${jiraIssueKey}`,
        "_blank"
      );
    },
    async getInvoice() {
      const response = await getInvoice(this.item.invoice.id);
      this.invoiceAmount = response.details.reduce(
        (sum, i) => sum + i.amount,
        0
      );
    },
    async getPayment() {
      const response = await getPaymentInvoices(this.item.invoice.id);
      this.paymentAmount = response.reduce((sum, i) => sum + i.amount, 0);
    },
    async assignJiraIssue() {
      this.loading = true;
      await assignJiraIssue(
        this.clientId,
        this.item.product.id, {
          JiraIssueKey: this.item.jiraIssueKey,
        });
      this.$emit("updateJiraKey", this.item.jiraIssueKey, this.item.product.id);
      this.loading = false;
    },
  },
};
</script>

<style scoped>
a {
  color: #000;
  text-decoration: none;
}
</style>